function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M41.999 13C26.019 13 13 26.02 13 42c0 15.98 13.019 28.998 28.999 28.998 6.91 0 13.26-2.444 18.249-6.5l21.624 21.624a3.009 3.009 0 0 0 4.25 0 3.009 3.009 0 0 0 0-4.25L64.496 60.249c4.056-4.99 6.5-11.34 6.5-18.25C70.997 26.019 57.978 13 42 13zm0 6a22.954 22.954 0 0 1 22.998 22.999A22.954 22.954 0 0 1 42 64.997a22.954 22.954 0 0 1-23-22.998 22.954 22.954 0 0 1 23-23z"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "search-icon",
  viewBox: "0 0 100 100"
}, props), _ref);

export default __webpack_public_path__ + "static/media/search-icon.d591c92c.svg";
export { SvgComponent as ReactComponent };